const i18 = require('i18n');

cc.Class({
    extends: cc.Component,

    properties: {
        sprite: cc.Sprite,
        prizeLayout: cc.Layout,
        winLengths: [cc.Label],
        prizes: [cc.Label]
    },

    setSpriteFrame (spriteFrame) {
        this.sprite.spriteFrame = spriteFrame;
    },

    onEnable() {
        this.prizeLayout.updateLayout();
    },

    setPrizes (prizes, coefficient) {
        prizes.forEach((prize, index) => {
            if (prize > 0) {
                prize *= coefficient;
                prize = i18.formatCurrency(prize);
                this.prizes[index].node.parent.active = true;
                this.prizes[index].string = prize;
                this.winLengths[index].string = (index + 1) + 'x';
            }
        });
        this.prizeLayout.updateLayout();
    }
});
